import axios from "axios";
export const TOKENS_CACHE_KEY = 'leonardo-tokens-cache';

// noinspection JSUnusedGlobalSymbols
export async function adjustUserTokenCount(cognitoSub, idToken, adjustment) {
  const response = await axios.post(process.env.SISER_API_ENDPOINT + 'user/cognito/' + cognitoSub + '/ai-token', adjustment, {
    headers: {
      'Authorization': idToken,
      'X-Siser-Elevated-Roles': '1'
    }
  });
  return response.data;
}
export async function userTokenCount(cognitoSub, idToken, useCache) {
  if (typeof window !== 'undefined' && useCache) {
    const cachedStr = window.sessionStorage.getItem(TOKENS_CACHE_KEY);
    if (cachedStr) {
      return JSON.parse(cachedStr);
    }
  }
  const response = await axios.get(process.env.SISER_API_ENDPOINT + 'user/cognito/' + cognitoSub + '/ai-token/count', {
    headers: {
      'Authorization': idToken,
      'Cache-Control': 'max-age=0'
    }
  });
  if (typeof window !== 'undefined') {
    window.sessionStorage.setItem(TOKENS_CACHE_KEY, JSON.stringify(response.data));
  }
  return response.data;
}